import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { SocialGroupService } from 'src/app/interfaces/social-groups.service';
import { Project } from 'src/app/swagger-api';
import { CardType } from 'src/app/views/cards/cards.types';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { UserTableCreators } from 'src/app/views/table-users-list/adapters/table-creator.enum';
import { SearchCategories } from '../../search/search.enum';
import { SocialGroupInvolvementContext } from '../../shared/counters/social-groups-involvement-counters-context.abstract';
import { ProjectsService } from '../projects.service';

@Component({
  selector: 'app-user-projects',
  templateUrl: './user-projects.component.html',
  styleUrls: ['./user-projects.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProjectsComponent extends SocialGroupInvolvementContext<Project> {
  protected SEARCH_INPUT_LABEL = 'SEARCH_PROJECT_FIELD_LABEL';
  // Success messages
  // - Confirm invite
  protected MANAGE_SOCIAL_GROUP_CONFIRM_INVITE_HINT = 'MANAGE_PROJECT_CONFIRM_INVITE_HINT';
  // - Reject invite
  protected MANAGE_SOCIAL_GROUP_REJECT_REQUEST_DIALOG_DESCRIPTION = 'MANAGE_PROJECT_REJECT_REQUEST_DIALOG_DESCRIPTION';
  protected MANAGE_SOCIAL_GROUP_REJECT_REQUEST_DIALOG_TITLE = 'MANAGE_PROJECT_REJECT_REQUEST_DIALOG_TITLE';
  protected MANAGE_SOCIAL_GROUP_REJECT_REQUEST_DIALOG_BTN_HINT = 'MANAGE_PROJECT_REJECT_REQUEST_DIALOG_BTN_HINT';
  // - Delete invite
  protected MANAGE_SOCIAL_GROUP_REJECT_USER_REQUEST_HINT = 'MANAGE_PROJECT_REJECT_USER_REQUEST_HINT';

  public readonly CardType: typeof CardType = CardType;

  private projectsService = inject(ProjectsService);

  protected getSocialGroupService(): SocialGroupService<Project> {
    return this.projectsService;
  }

  protected columnTypes(): ColumnTypes {
    return ColumnTypes.PROJECT;
  }

  protected searchCategories(): SearchCategories.PROJECTS {
    return SearchCategories.PROJECTS;
  }

  protected userRequestTableCreators(): UserTableCreators {
    return UserTableCreators.PERSONAL_USER_REQUESTS_FOR_PROJECT;
  }

  protected userInvitesTableCreators(): UserTableCreators {
    return UserTableCreators.PERSONAL_USER_INVITES_FOR_PROJECT;
  }
}
